import Button from "../../../Buttons/Button";
import {ButtonSize} from "../../../../Data/Enums/Generic";
import {ColourMod} from "../../../../Data/Enums/LayoutEnums";
import React from "react";
import {ComboBoxListActionsType} from "../ComboBoxTypes";

const ComboBoxListActions = (props: ComboBoxListActionsType) => {
    return (
        <div className={'multi-select-actions sticky p-xs btn-group mb-0'}>
            <Button title={'All'} size={ButtonSize.Small} fullWidth={true} squared={true} onClick={() => props.toggleCallBack(!props.allSelected)} colour={props.allSelected ? ColourMod.Selected: ColourMod.Secondary} />
            <Button title={'Reset'} size={ButtonSize.Small} fullWidth={true} squared={true} onClick={() => props.resetCallBack ? props.resetCallBack(false) : props.toggleCallBack(false) } colour={ColourMod.Secondary} />
        </div>
    )
}

export default ComboBoxListActions